export default 60000 // Ext.Ajax.timeout default
